export default "__VITE_ASSET__CUPnBpwj__"